<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="clientDataSource" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight">
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="id" :visible="false"></e-column>
            <e-column field="startAddress" :headerText="$t('Security.client.startAddress')" width="120" textAlign="Center"></e-column>
            <e-column field="endAddress" :headerText="$t('Security.client.endAddress')" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getDataSource"
        ></ejs-pager>
      </div>
      <CustomDialog
        ref="addClientDialog"
        v-bind:element="addDialog.element"
        v-bind:styles="addDialog.styles"
      >
        <template v-slot:dialog-content>
          <ClientOption ref="addClient" :baseType="add"></ClientOption>
        </template>
      </CustomDialog>
      <CustomDialog
        ref="modifyClientDialog"
        v-bind:element="editDialog.element"
        v-bind:styles="editDialog.styles"
      >
        <template v-slot:dialog-content>
          <ClientOption ref="modifyClient" :baseType="modify"></ClientOption>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import ClientOption from '../../components/security/clientManager/clientOption';

export default {
  name: 'Client',
  components: {
    BasicLayout,
    CustomDialog,
    ClientOption
  },
  data() {
    return {
      add: 'add',
      modify: 'modify',
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.clientRules')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showModifyDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteClientRule },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid }
      ],
      clientDataSource: '',
      pageSettings: {
        pageSize: 15
      },
      page: {
        pageCount: 4,
        pageNo: 1,
        totalRecordsCount: 0
      },
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addClientDialog',
          buttonGroup: [
            {
              click: this.addDialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addClient,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Security.client.addClient')}`
        },
        styles: {
          width: '800px',
          height: '350px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'modifyClientDialog',
          title: `${this.$t('Security.client.editClient')}`,
          buttonGroup: [
            {
              click: this.modifyDialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.modifyClient,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ]
        },
        styles: {
          width: '800px',
          height: '350px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 240
    }
  },
  mounted() {
    this.getDataSource();
    let That = this;
    window.onresize = () => {
      return (() => {
        That.screenHeight = document.body.clientHeight - 240;
      })()
    }
  },
  methods: {
    getDataSource() {
      const url = '/lte/ems/client/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
          pageNo: this.page.pageNo,
          pageSize: this.pageSettings.pageSize
        } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        That.clientDataSource = result;
        That.page.totalRecordsCount = response.data.totalCount;
        That.$refs.grid.clearSelection()
      });
    },
    showAddDialog() {
      this.$refs.addClient.init();
      this.$refs.addClientDialog.show();
    },
    showModifyDialog() {
      let record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.$refs.modifyClient.init(record[0].id);
      this.$refs.modifyClientDialog.show();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    addClient() {
      let validResult = this.$refs.addClient.validation();
      if (validResult) {
        const url = '/lte/ems/client/save';
        let param = this.$refs.addClient.getParam();
        let That = this;
        this.axios.post(url, param).then(response => {
          const result = response.data;
          if(result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getDataSource();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.addDialogHide();
        });
      }
    },
    modifyClient() {
      let validResult = this.$refs.modifyClient.validation();
      if (validResult) {
        const url = '/lte/ems/client/modify';
        let param = this.$refs.modifyClient.getParam();
        let That = this;
        this.axios.post(url, param).then(response => {
          const result = response.data;
          if(result) {
            That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
            That.getDataSource();
          } else {
            That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
          }
          That.modifyDialogHide();
        });
      }
    },
    deleteClientRule() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/ems/client/delete';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getDataSource();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    addDialogHide() {
      this.$refs.addClientDialog.clear();
      this.$refs.addClientDialog.close();
    },
    modifyDialogHide() {
      this.$refs.modifyClientDialog.clear();
      this.$refs.modifyClientDialog.close();
    },
    refreshGrid() {
      this.getDataSource();
    }
  }
}
</script>
